<template>

    <table v-if="selectedComponent" class="table mt-2 border-bottom" style="margin-bottom: 0px;font-size: .85rem;">
        <tbody>

        <tr class="info-row">
            <td colspan="2" class="editor-content bg-primary text-white"><strong>Component - {{selectedComponent.type}}</strong></td>
        </tr>

        <label-editor v-if="notContentEditable"
                      :selected-component="selectedComponent"></label-editor>
        <label-size-editor v-if="hasLabel"
                              :selected-component="selectedComponent"></label-size-editor>
        <tag-editor v-if="selectedComponent.type === 'Header'"
                    :selected-component="selectedComponent"></tag-editor>

        <text-align-selector v-if="(isLabel || isHeader)"
                        :selected-component="selectedComponent"></text-align-selector>

        <min-max-width-height-editor v-if="isLabel"
                :selected-component="selectedComponent" property="maxWidth"></min-max-width-height-editor>

        <context-color-editor v-if="supportsContextColor"
                              :selected-component="selectedComponent" label="Color"></context-color-editor>

        <tr v-if="supportsCustomColor && isCustomColor">
            <td class="editor-content editor-label">Custom color</td>
            <td class="editor-content">
                <color-picker :color-object="selectedComponent.style" color-field="color" class="mt-1" :shift-left="true"></color-picker>
            </td>
        </tr>

        <context-color-editor v-if="supportsBgColor"
                              :selected-component="selectedComponent" label="Background Color"></context-color-editor>

        <tr v-if="isCustomBackgroundColor && supportsBgColor">
            <td class="editor-content editor-label">Custom background color</td>
            <td class="editor-content">
                <color-picker :color-object="selectedComponent.style" color-field="backgroundColor" class="mt-1" :shift-left="true"></color-picker>
            </td>
        </tr>

        <view-link-properties v-if="view && isLinkable" :view="view" :selected-component="selectedComponent"></view-link-properties>

        <website-link-properties v-else-if="isLinkable" :page="page" :selected-component="selectedComponent"></website-link-properties>

        <tr v-if="isLabel">
            <td class="editor-content editor-label">Weight</td>
            <td class="editor-content">
                <select class="form-control editor-form editor-select"
                        v-model="selectedComponent.style.fontWeight">
                    <option>normal</option>
                    <option>bold</option>
                </select>
            </td>
        </tr>

        <tr v-if="isLabel || isText">
            <td class="editor-content editor-label">Truncate</td>
            <td class="editor-content">
                <input type="checkbox" v-model="selectedComponent.style.nowrap">
            </td>
        </tr>

        <tr v-if="isHeader">
            <td class="editor-content editor-label">Animate</td>
            <td class="editor-content">
                <input type="checkbox" id="animateCheckbox" v-model="selectedComponent.animate">
            </td>
        </tr>

        <tr v-if="isHeader">
            <td class="editor-content editor-label">Background</td>
            <td class="editor-content">
                <input type="checkbox" id="headerBgCheck" v-model="selectedComponent.includeBackground">
            </td>
        </tr>

        <tr v-if="isVideo">
            <td class="editor-content editor-label">URL</td>
            <td class="editor-content">
                <input type="text" class="form-control" id="videoUrlInput" placeholder="https://" v-model="selectedComponent.value.url">
            </td>
        </tr>

        <tr v-if="isVideo">
            <td class="editor-content editor-label">Embed HTML</td>
            <td class="editor-content">
                <textarea id="embedHtmlInput" type="text" class="form-control"
                          placeholder="Youtube Embed HTML"
                          v-model="selectedComponent.value.embedHtml"></textarea>
            </td>
        </tr>



        <tr v-if="isHeader && selectedComponent.animate">
            <td class="editor-content editor-label">Animation</td>
            <td class="editor-content">
                <button class="btn btn-sm btn-success" @click="onEditAnimationClick">edit</button>
            </td>
        </tr>

        <tr v-if="isView">
            <td class="editor-content editor-label">Display Header</td>
            <td class="editor-content">
                <input type="checkbox" id="checkbox" v-model="selectedComponent.showHeader">
            </td>
        </tr>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Margin</td>
        </tr>

        <margin-selector :spacing="selectedComponent.margin"></margin-selector>

        <tr class="info-row">
            <td colspan="2" class="editor-content">Padding</td>
        </tr>

        <margin-selector :spacing="selectedComponent.padding"></margin-selector>

        <image-border-selector v-if="isImage"
                        :selected-component="selectedComponent"></image-border-selector>

        <tr v-if="isImage" class="info-row">
            <td class="editor-content editor-label">Width</td>
            <image-size-style :selected-component="selectedComponent" property="width"></image-size-style>
        </tr>

        <tr v-if="isImage" class="info-row">
            <td class="editor-content editor-label">Height</td>
            <image-size-style :selected-component="selectedComponent" property="height"></image-size-style>
        </tr>

        <image-fit-selector v-if="isImage"
                :selected-component="selectedComponent"></image-fit-selector>


        </tbody>
    </table>
</template>

<script>
    import LayoutFactory from "../../utils/LayoutFactory";
    import LayoutUtil from "../../utils/LayoutUtil";
    import LabelEditor from "./LabelEditor.vue";
    import LabelSizeEditor from './LabelSizeEditor.vue'
    import TagEditor from './TagEditor.vue'
    import ContextColorEditor from "./ContextColorEditor.vue";
    import IconSizeEditor from './IconSizeEditor.vue'
    import MarginSelector from "./MarginSelector.vue";
    import ColorPicker from "../../components/ColorPicker.vue";
    import ImageBorderSelector from './ImageBorderSelector.vue'
    import TextAlignSelector from './TextAlignSelector.vue'
    import ImageSizeStyle from './ImageSizeStyle.vue'
    import ImageFitSelector from './ImageFitSelector.vue'
    import BorderRadiusEditor from './BorderRadiusEditor.vue'
    import MinMaxWidthHeightEditor from './MinMaxWidthHeightEditor.vue'
    import ViewLinkProperties from "./ViewLinkProperties.vue";
    import WebsiteLinkProperties from "./WebsiteLinkProperties.vue";

    export default {
        name: 'ComponentProperties',
        components: {
            WebsiteLinkProperties,
            ViewLinkProperties,
            ColorPicker, MarginSelector, ContextColorEditor, LabelEditor, LabelSizeEditor, TagEditor, IconSizeEditor,
            ImageBorderSelector, TextAlignSelector, ImageSizeStyle, ImageFitSelector, BorderRadiusEditor, MinMaxWidthHeightEditor},
        props: ['layout', 'view', 'page', 'component'],
        data() {
            return {
                model: webase.model,
                factory: new LayoutFactory(),
                layoutUtil: new LayoutUtil()
            }
        },
        computed: {
            isCustomColor() {
                return this.selectedComponent.style && this.selectedComponent.style.color && (this.selectedComponent.style.color === 'custom' || this.selectedComponent.style.color.indexOf('#') === 0)
            },
            isCustomBackgroundColor() {
                return this.selectedComponent.style && this.selectedComponent.style.backgroundColor && (this.selectedComponent.style.backgroundColor === 'custom' || this.selectedComponent.style.backgroundColor.indexOf('#') === 0)
            },
            selectedComponent() {
                return this.component ? this.component : this.layout.selectedComponent
            },
            notContentEditable() {
                return this.selectedComponent.type === 'Link'
            },
            hasLabel() {
                return this.selectedComponent.type === 'Label' || this.selectedComponent.type === 'Header' ||
                    this.selectedComponent.type === 'Link' || this.selectedComponent.type === 'Text'
            },
            supportsBgColor() {
                return this.isHeader && this.selectedComponent.includeBackground
            },
            isLink() {
                return this.selectedComponent.type === 'Link'
            },
            isLinkable() {
                return this.isLink || this.isIcon || this.isImage
            },
            isLabel() {
                return this.selectedComponent.type === 'Label'
            },
            isText() {
                return this.selectedComponent.type === 'Text'
            },
            isHeader() {
                return this.selectedComponent.type === 'Header'
            },
            isView() {
                return this.selectedComponent.type === 'View'
            },
            isIcon() {
                return this.selectedComponent.type === 'Icon'
            },
            isImage() {
                return this.selectedComponent.type === 'Image'
            },
            isVideo() {
                return this.selectedComponent.type === 'Video'
            },
            supportsContextColor() {
                return this.selectedComponent.type === 'Label' ||
                    this.selectedComponent.type === 'Header' || this.selectedComponent.type === 'Icon' ||
                    this.selectedComponent.type === 'Link' || this.selectedComponent.type === 'Text'
            },
            supportsCustomColor() {
                return this.selectedComponent.type === 'Label' || this.selectedComponent.type === 'Header' || 
                    this.selectedComponent.type === 'Icon' || this.selectedComponent.type === 'Link' ||
                    this.selectedComponent.type === 'Text'
            },
            views() {
                let appViews = webase.managers.app.getViews()
                return appViews.filter(view => view.id !== this.view.id)
            }
        },
        mounted() {
        },
        methods: {
            onWidthSelected() {
                this.layoutUtil.setColumnWidths(this.column, this.layout.selectedRow.columns)
            },
            onViewSelected() {
                this.selectedComponent.resourceType = "View"
            },
            onUrlSelected() {
                this.selectedComponent.resourceType = "URL"
                this.selectedComponent.resource = ''
            },
            onEditAnimationClick() {
                webase.eventDispatcher.emit('editAnimationClick')
            },
            onEditIconClick() {
                webase.eventDispatcher.emit('editIconClick')
            }
        }
    }
</script>

<style>

</style>
